export const unityProjectData = [
  {
    id: 'smartsave-pro',
    title: 'SmartSave Pro - Advanced Save & Load System',
    category: 'Unity Plugin / Data Persistence',
    description:
      'A complete, production-ready Save & Load solution featuring AES encryption, autosave triggers, backup recovery, multi-save slots, and a custom Unity Editor debugging window.',
    tags: ['Unity', 'C#', 'Data Encryption', 'JSON', 'Custom Editor'],
    featured: true,
    assetStoreUrl: 'https://u3d.as/3LeZ'
  },
  {
    id: 'main-menu-dark-duty',
    title: 'Main Menu - Dark Duty',
    category: 'Unity UI Kit',
    description:
      'A collection of professionally designed, dark-themed UI components (menus, buttons, sliders, pop-ups). Fully customizable for sci-fi, cyberpunk, horror, and minimalist games.',
    tags: ['Unity', 'C#', 'UI Toolkit', 'Dark Theme', 'Game UI'],
    featured: false,
    assetStoreUrl: 'https://u3d.as/3b0i'
  },
  {
    id: 'ultimate-game-menu',
    title: 'Ultimate Game Menu',
    category: 'Unity UI System',
    description:
      'A versatile, all-in-one menu system designed to simplify in-game menu creation. Fully adaptable to match any game genre, visual style, or project theme.',
    tags: ['Unity', 'C#', 'UGUI', 'Modular UI'],
    featured: false,
    assetStoreUrl: 'https://u3d.as/2VGx'
  },
  {
    id: 'animated-main-menu',
    title: 'Animated Main Menu',
    category: 'Unity UI Kit',
    description:
      'A versatile asset offering customizable UI animations, effects, and smooth transitions to create visually appealing main menus across multiple game genres.',
    tags: ['Unity', 'C#', 'UI Animation', 'Transitions'],
    featured: false,
    assetStoreUrl: 'https://u3d.as/35k6'
  }
];